import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderRadius: '3px',
    overflow: 'hidden',
  },
  clickable: {
    cursor: 'pointer',
  },
  avatar: {
    height: theme.typography.pxToRem(56),
    width: theme.typography.pxToRem(56),
    flexShrink: 0,
  },
  active: {
    backgroundColor: theme.palette.action.selected,
  },
  creditInfo: {
    padding: theme.spacing(0, 2),
  },
}));
